import { render, staticRenderFns } from "./TreasuryEdit.vue?vue&type=template&id=9a07a5a0&scoped=true&"
import script from "./TreasuryEdit.vue?vue&type=script&lang=js&"
export * from "./TreasuryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a07a5a0",
  null
  
)

export default component.exports